/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/jsx-indent */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable import/no-cycle */
/* eslint-disable no-param-reassign */
import React, { useState, useEffect, useRef, useCallback } from 'react';
import {
  ScheduleComponent,
  ViewsDirective,
  ViewDirective,
  Day,
  Week,
  WorkWeek,
  Month,
  Agenda,
  Inject,
  Resize,
  DragAndDrop,
} from '@syncfusion/ej2-react-schedule';
import { ToolbarComponent, ItemsDirective, ItemDirective } from '@syncfusion/ej2-react-navigations';
import { DialogComponent, DialogUtility } from '@syncfusion/ej2-react-popups';
import { Link, useNavigate } from 'react-router-dom';
import { GroupContent, Header, EditorForm } from '../components';
import { useStateContext } from '../contexts/ContextProvider';
import scribeHow from '../data/scribehow.png';

import './Zackat.css';

const Campaign = () => {
  const navigate = useNavigate();
  let usr = localStorage.getItem('user');
  let selectedOrg = localStorage.getItem('organization');
  if (!usr || !selectedOrg) {
    // Redirect
    navigate('/login?landing=calendar');
    return <p>Please login... </p>;
  }
  usr = JSON.parse(usr);
  selectedOrg = JSON.parse(selectedOrg);
  const scheduleObj = useRef(null);
  const { REACT_APP_API_ENDPOINT } = process.env;
  const {
    boss,
    setGroups,
    isDialogOpen,
    setIsDialogOpen,
  } = useStateContext();

  useEffect(() => {
    const dataFetch = async () => {
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/campaigngroup?${query}`;
      const mydata = await (
        await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
        })
      ).json()
        .catch((err) => {
          console.error('Error parsing JSON:', err);
          return null;
        });
        // set state when the data received
      if (mydata && mydata.length > 0) {
        const mygroups = [];
        // mygroups.push({ _id: 'na', name: 'Add New', associates: [], devices: [], organization: '' });
        mydata.forEach((element) => {
          mygroups.push(element);
        });
        setGroups(mygroups);
      } else {
        setGroups([]);
      }
    };
    dataFetch();
  }, []);
  const onDragStart = (arg) => {
    // eslint-disable-next-line no-param-reassign
    arg.navigation.enable = true;
  };
  const [data, setData] = useState([]);
  const [dropdownFotaData, setDropDownFotaData] = useState([]);
  const [smsData, setSmsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [smsloading, setSMSLoading] = useState(true);
  // const [isNewEvent, setIsNewEvent] = useState(true);
  const [editing, setEditing] = useState(false);
  // const [subject, setSubject] = useState('');

  const grpbuttons = [
    {
      // Click the footer buttons to hide the Dialog
      click: () => {
        setIsDialogOpen(false);
      },
      // Accessing button component properties by buttonModel property
      buttonModel: {
        // Enables the primary button
        isPrimary: true,
        content: 'Cancel',
      },
    },
  ];
  const grpTemplate = () => <GroupContent props={data} />;
  const onToolbarChange = (args) => {
    if (args && args.target && args.target.textContent) {
      if (args.target.textContent === 'Groups' || (args.target && args.target.classList.contains('e-selection'))) {
        setIsDialogOpen(true);
      }
    } else if (args.target && args.target.classList.contains('e-selection')) {
      setIsDialogOpen(true);
    }
  };

  useEffect(() => {
    // limit associates to the overall selection
    if (selectedOrg && selectedOrg.id && selectedOrg.id.length > 0) {
      usr.organizationid = selectedOrg.id;
    }
    // fetch data
    const dataFetch = async () => {
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/campaign_events?${query}`;
      const mydata = await (
        await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
        })
      ).json()
        .catch((err) => {
          console.error('Error parsing JSON:', err);
          return null;
        });
      // set state when the data received
      if (mydata && mydata.fotas) {
        setDropDownFotaData(mydata.fotas);
      }
      setData(mydata);
      setLoading(false);
    };
    dataFetch();
  }, []);
  useEffect(() => {
    // limit associates to the overall selection
    if (selectedOrg && selectedOrg.id && selectedOrg.id.length > 0) {
      usr.organizationid = selectedOrg.id;
    }
    // fetch data
    const smsFetch = async () => {
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/sms_config?${query}`;
      const mydata = await (
        await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
        })
      ).json()
        .catch((err) => {
          console.error('Error parsing JSON:', err);
          return null;
        });
      // set state when the data received
      setSmsData(mydata.sms);
      setSMSLoading(false);
    };
    smsFetch();
  }, []);
  /*
  const editorHeaderTemplate = (args) => {
    let campaign = 'New Campaign';
    if (args && args.Subject && args.Subject.length > 0) {
      campaign = `Edit Campaign ${args.Subject}`;
    }
    return (
    // Check if the event is new based on the presence of an `Id`
    // Display "New Campaign" for new events, or the event's subject for existing ones
    // {isNewEvent ? 'New Campaign' : `Edit ${subject}`}
    <div style={{ padding: '10px', fontSize: '18px', fontWeight: 'bold' }}>
      {campaign}
      </div>
    );
  };
*/
  const onNavigation = (args) => {
    if (editing) {
      args.cancel = true;
    }
  };

  const onPopupClose = () => {
    setEditing(false);
  };

  const onPopupOpen = (args) => {
    if (args.type === 'Editor') {
      setEditing(true);
      /*
      if (!args.data.Id || args.data.Id === '') {
        setIsNewEvent(true);
        setSubject('Campaign Event');
      } else {
        setIsNewEvent(false);
        setSubject(`${args.data.Subject}`);
      }
      */
      /*
      const statusElement = args.element.querySelector('#EventType');
      if (statusElement) {
        statusElement.setAttribute('name', 'EventType');
      }
        */
    } else {
      setEditing(false);
    }

    if (args.type === 'QuickInfo') {
      args.cancel = true; // Prevent quick info popup from rendering
      // scheduleObj.current.openEditor(args.data, 'EditEvent'); // Force direct editor template opening
    }
  };

  const editorTemplate = useCallback((props) => <EditorForm props={props} orgs={data.organization} fotas={dropdownFotaData} sms={smsData} />, [smsloading, loading]);

  if (loading || smsloading) {
    return <p>Loading... </p>;
  }
  if (!boss) {
    return <p>Not Authorized... </p>;
  }
  const onRendercell = (args) => {
    (args.element).style.background = args.data.CategoryColor;
  };
  const onActionBegin = (args) => {
    // Check if the action is triggered by navigation or toolbar rendering,
    // and cancel it if a popup/modal interaction is in progress
    if (args.requestType === 'viewNavigate' || args.requestType === 'dateNavigate') {
      // Add your condition here to block changes if needed
      if (editing) {
        args.cancel = true;
      }
    }
  };

  const actionComplete = (args) => {
    let editedData;
    setEditing(false);
    if (!args || !args.requestType) {
      return;
    }
    if ((args.requestType === 'beginEdit' || args.requestType === 'add')) {
      /** Add Validation Rules */
    }
    /** Set initial Focus */
    if (args.requestType === 'eventCreated' && args.addedRecords.length > 0) {
      editedData = args.addedRecords;
      if (!editedData[0].EventType) {
        DialogUtility.alert('Please select an Event Type!');
        args.cancel = true;
        return;
      }
      if (editedData[0].FOTAImage && editedData[0].FOTAImage && editedData[0].FOTAImage.length > 0 && editedData[0].EventType !== 'fota') {
        DialogUtility.alert(`Event Type ${editedData[0].EventType} should not be assigned a FOTA Image!`);
        args.cancel = true;
        return;
      }
      if (editedData[0].Description && editedData[0].Description.length > 0 && editedData[0].EventType === 'fota') {
        DialogUtility.alert(`Message for Event Type ${editedData[0].EventType} should not be assigned!`);
        args.cancel = true;
        return;
      }
      if (editedData[0].FOTAImage && editedData[0].FOTAImage && editedData[0].FOTAImage.length === 0 && editedData[0].EventType === 'fota') {
        DialogUtility.alert(`FOTAImage for Event Type ${editedData[0].EventType} may not be omitted!`);
        args.cancel = true;
        return;
      }
      if (!editedData[0].organizationid) {
        DialogUtility.alert(`Please select an Organization for Event Type ${editedData[0].EventType}!`);
        args.cancel = true;
        return;
      }
      if (!editedData[0].group) {
        DialogUtility.alert(`Please select a Group for Event Type ${editedData[0].EventType}!`);
        args.cancel = true;
        return;
      }
      editedData[0].stime = new Date(editedData[0].StartTime).getTime() / 1000;
      editedData[0].etime = new Date(editedData[0].EndTime).getTime() / 1000;
      if (editedData[0].etime <= new Date().getTime() / 1000) {
        DialogUtility.alert(`Event Type ${editedData[0].EventType} has already passed ${editedData[0].EndTime}!`);
        args.cancel = true;
        return;
      }
      switch (editedData[0].EventType) {
        case 'sms':
          editedData[0].CategoryColor = '#00ffff';
          break;
        case 'push':
          editedData[0].CategoryColor = '#78DA89';
          break;
        case 'email':
          editedData[0].CategoryColor = '#1E1B1B';
          break;
        case 'fota':
          editedData[0].CategoryColor = '#aaaaaa';
          break;
        case 'device':
          editedData[0].CategoryColor = '#557755';
          break;
        default:
          break;
      }
      // The default edit operation is cancelled
      // Here you can send the updated data to your server using AJAX call
      fetch(`${REACT_APP_API_ENDPOINT}/campaign_events`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `JWTToken ${usr.token}`,
        },
        body: JSON.stringify(editedData),
      })
        .then((response) => response.json())
        .then((responseJson) => {
          if (responseJson && responseJson._id) {
            for (let i = 0; i < args.addedRecords.length; i += 1) {
              if (responseJson[i] && responseJson[i]._id) {
                args.addedRecords[i]._id = responseJson[i]._id;
              }
            }
          }
          // The added/edited data will be saved in the Grid
        })
        .catch((error) => {
          console.error(error);
        });
    } else if (args.requestType === 'eventChanged' && args.changedRecords.length > 0) {
      editedData = args.changedRecords;
      if (!editedData[0].EventType) {
        DialogUtility.alert('Please select an Event Type!');
        args.cancel = true;
        return;
      }
      /*
      if (editedData[0].FOTAImage && editedData[0].FOTAImage.length > 0 && editedData[0].EventType !== 'fota') {
        DialogUtility.alert(`Event Type ${editedData[0].EventType} should not be assigned a FOTA Image!`);
        args.cancel = true;
        return;
      }
      */
      if (editedData[0].Description && editedData[0].Description.length > 0 && editedData[0].EventType === 'fota') {
        DialogUtility.alert(`Message for Event Type ${editedData[0].EventType} should not be assigned!`);
        args.cancel = true;
        return;
      }
      if (editedData[0].FOTAImage && editedData[0].FOTAImage.length === 0 && editedData[0].EventType === 'fota') {
        DialogUtility.alert(`FOTAImage for Event Type ${editedData[0].EventType} may not be omitted!`);
        args.cancel = true;
        return;
      }
      // The default edit operation is cancelled
      // Here you can send the updated data to your server using AJAX call
      editedData[0].stime = new Date(editedData[0].StartTime).getTime() / 1000;
      editedData[0].etime = new Date(editedData[0].EndTime).getTime() / 1000;
      if (editedData[0].etime <= new Date().getTime() / 1000) {
        DialogUtility.alert(`Event Type ${editedData[0].EventType} has already passed ${editedData[0].EndTime}!`);
        args.cancel = true;
        return;
      }
      if (!editedData[0].organizationid) {
        DialogUtility.alert(`Please select an Organization for Event Type ${editedData[0].EventType}!`);
        args.cancel = true;
        return;
      }
      if (!editedData[0].group) {
        DialogUtility.alert(`Please select a Group for Event Type ${editedData[0].EventType}!`);
        args.cancel = true;
        return;
      }
      editedData[0].logs = null;
      fetch(`${REACT_APP_API_ENDPOINT}/campaign_events`, {
        method: 'UPDATE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `JWTToken ${usr.token}`,
        },
        body: JSON.stringify(editedData),

      })
        .then((response) => response.json())
        .then(() => {
          // The added/edited data will be saved in the Grid
        })
        .catch((error) => {
          console.error(error);
        });
    } else if (args.requestType === 'eventRemoved' && args.deletedRecords.length > 0) {
      editedData = args.deletedRecords;
      // The default edit operation is cancelled
      // Here you can send the updated data to your server using AJAX call
      fetch(`${REACT_APP_API_ENDPOINT}/campaign_events`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `JWTToken ${usr.token}`,
        },
        body: JSON.stringify(editedData),

      })
        .then((response) => response.json())
        .then(() => {
          // The added/edited data will be saved in the Grid
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };
  //          to="https://scribehow.com/viewer/Campaigns_use_and_features__eHkvNLXqQ66fYHg6tlLrlQ"

  return (
    <div className="m-2 md:m-1 mt-2 p-1 md:p-4 bg-white rounded-3xl zackat-divalh">
            <div className="flex">
        <Link
          className="my-link"
          to="/pdf/campaign.pdf"
          target="_blank"
        >
          <img src={scribeHow} width={20} height={20} />
        </Link>
      <Header category="Apps" title="Campaign" />
      </div>
      <ToolbarComponent id="toolbar" onClick={onToolbarChange} overflowMode="MultiRow">
        <ItemsDirective>
          <ItemDirective text="Groups" prefixIcon="e-selection" visible />
      </ItemsDirective></ToolbarComponent>
      <ScheduleComponent
        height="650px"
        ref={scheduleObj}
        selectedDate={new Date()}
        eventSettings={{ dataSource: data.campaign }}
        eventRendered={onRendercell}
        dragStart={onDragStart}
        popupOpen={onPopupOpen}
        popupClose={onPopupClose}
        navigating={onNavigation}
        showQuickInfo={false}
        editorTemplate={editorTemplate}
        // editorHeaderTemplate={editorHeaderTemplate}
        actionComplete={actionComplete}
        actionBegin={onActionBegin}
        // eventClick={actionBegin}
      >
        <ViewsDirective>
          {['Day', 'Week', 'WorkWeek', 'Month', 'Agenda'].map((item) => (
            <ViewDirective
              key={item}
              option={item}
            />
          ))}
        </ViewsDirective>
        <Inject services={[Day, Week, WorkWeek, Month, Agenda, Resize, DragAndDrop]} />
      </ScheduleComponent>
      {/*
      <PropertyPane>
        <table
          style={{ width: '100%', background: 'white' }}
        >
          <tbody>
            <tr style={{ height: '50px' }}>
              <td style={{ width: '100%' }}>
                <DatePickerComponent
                  value={new Date()}
                  showClearButton={false}
                  placeholder="Current Date"
                  floatLabelType="Always"
                  change={change}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </PropertyPane>
      */}
      {isDialogOpen && (
        <DialogComponent
          header="Campaign Groups"
          content={grpTemplate}
          buttons={grpbuttons}
          width="75%"
          height="75%"
          isModal
          visible
          closeOnEscape
          showCloseIcon
          onClose={() => { setIsDialogOpen(false); }}
          close={() => { setIsDialogOpen(false); }}
        />
      )}
    </div>
  );
};

export default Campaign;
